<template>
    <div class="q-gutter-x-sm" :class="$q.screen.xs ? 'q-gutter-y-sm' : 'row'">
        <div class="col-4 q-gutter-y-sm">
            <q-input filled readonly v-model="produto.codAgpComercial" label="Codigo Agrupamento Comercial" />
            <q-input filled readonly v-model="produto.descAgpComercial" label="Descrição Agrupamento Comercial" />
            <q-input filled readonly v-model="produto.codAgpEstoque" label="Codigo Agrupamento por Estoque" />
            <q-input filled readonly v-model="produto.descAgpEstoque" label="Descrição Agrupamento por Estoque" />
            <q-input filled readonly v-model="produto.marca" label="Marca" />
            <q-btn @click="() => pesquisarEcommerceReduzido()" color="primary" class="q-mt-sm" label="e-Commerce" />
        </div>
        <div class="col" style="height: 95%;">
            <q-btn label="ver fotos" icon="image" class="full-width" v-if="produto.urlsImagens" @click="() => abrirModalFoto(produto.urlsImagens)" color="primary"/>
            <q-lins-table
                id="tableEstoqueDetalhe"
                ref="tableEstoqueDetalhe"
                :keyField="'cod_barras'"
                :data-table="formataDados"
                :auto-load="false"
                :pagination="false"
                :columns="columns"
                :show-copy-button="true"
                :copy-field="'cod_barras'"
                :copy-message="'Copiar codigo de barras'"
            />
            <q-visualizador-foto ref="modalFotos" />
        </div>
    </div>
</template>
<script>

    import { ref } from 'vue';
    import { mapGetters } from 'vuex';
    import QLinsTable from '@/shared/QLinsDrfTable.vue';
    import QVisualizadorFoto from './QVisualizadorFoto.vue';

    export default {
        name: "QTabInfomacao",
        components: {
            QLinsTable,
            QVisualizadorFoto
        },
        props: {
            dados: {
                type: Object,
                default: () => { }
            },
            listaProdutos: {
                type: Array,
                default: () => { }
            }
        },
        setup(props) {
            const produto = ref(props.dados);
            const produtos = ref([]);
            const lista = ref(props.listaProdutos[0].loja.produtos);
            
            const columns = ref([
                {
                    name: "cor",
                    field: "cor",
                    label: "Cor",
                    align: "start",
                },
                {
                    name: "tamanho",
                    field: "cod_tamanho",
                    label: "Tamanho",
                    align: "center",
                },
                {
                    name: "preco",
                    field: "preco",
                    format: val => `R$${parseFloat(val).toFixed(2)}`,
                    label: "Preço venda",
                    align: "center",
                },
                {
                    name: "cod_produto",
                    field: "cod_produto",
                    label: "Cod Produto",
                    align: "center",
                },
                {
                    name: "cod_barras",
                    field: "cod_barras",
                    label: "Cod Barras",
                    align: "center",
                },
                {
                    name: "acoes",
                    label: "Ações",
                    align: "center",
                    field: "acoes",
                    format: (val, row) => {
                        if (row.link != "" && row.link != undefined){
                            return `<button class="q-btn bg-primary text-white q-btn--actionable q-focusable" onclick="pesquisarEcommerce('${row.link}', '${row.cod_produto}')">e-Commerce</button>`;
                        }
                    }
                }
            ])

            return {
                produto,
                produtos,
                lista,
                columns
            }
    },
    computed: {
        ...mapGetters(['getNomeUsuario']),
        formataDados() {
            let produtos = []
            this.lista.map(dado => {
                dado.tamanhos.map(tam => {
                    tam.cor01 = dado.cor_predominante
                    tam.cor02 = dado.cor_02 ? `/ ${dado.cor_02}` : ''
                    tam.cor03 = dado.cor_03 ? `/ ${dado.cor_03}` : ''
                    tam.cor = tam.cor01 + tam.cor02 + tam.cor03
                    tam.cod_produto = dado.cod_produto
                    produtos.push(tam)
                })
            })
            return produtos
        }
    },
        methods: {
            abrirModalFoto(fotos) {
                this.$refs.modalFotos.show(fotos);
            },
            pesquisarEcommerceReduzido() {

            let api_vtex_error = localStorage.getItem('api_vtex_error');
            if (api_vtex_error == 'true'){
                window.warningMessage("Erro na consulta da API da vTex. Contate o administrador do sistema!");
            }
            else {

                let link_gang = 'https://www.gang.com.br/';
                let link_pompeia = 'https://www.lojaspompeia.com/';
                let codProduto = document.getElementById("tableEstoqueDetalheCell3_0").firstChild.textContent;
                let codReduzido = codProduto.substring(7, 12);
                let empresa = codProduto[0];
                let link_to_open = "";

                if (empresa == "1"){
                    link_to_open = `${link_pompeia}${codReduzido}?utm_source=loja&utm_medium=loja-${empresa}&utm_campaign=consulta-estoque`;
                }

                else if (empresa == "2"){
                    link_to_open = `${link_gang}${codReduzido}?utm_source=loja&utm_medium=loja-${empresa}&utm_campaign=consulta-estoque`;
                }

                if (link_to_open != ""){
                    window.open(link_to_open, "_blank");
                }
            }

        }
        },
    };

</script>
